import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import BoxContent from "@src/component/Desktop/content";
import { Button, Col, Modal, Row, Tabs } from "antd";
import { debounce } from "lodash";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { FacilityMasterApi } from "../../api/backend/facilityMaster";
import kbn from "../../api/backend/kbn";
import Loading from "../../component/Desktop/loading/loading";
import TitlePage from "../../component/Desktop/titlePage";
import FooterPage from "../../component/footer/footerPage";
import {
  COMMON_CONSTANT,
  INPUT_TYPE,
  KEY,
  lang,
  MODE_SCREEN,
  REGEX_INPUT,
} from "../../constants/common.const";
import { handleCatchError, showMessage } from "../../constants/utils";
import classDdl from "../../models/control/dropdownlist";
import classGrid from "../../models/control/grid";
import classText from "../../models/control/text";
import { formatDecimal, formatNumberFloat, isEmptyData } from "../../utils/helper";
import BasicInformation from "./basicInformation";
import FormSearchFacility from "./formSearchFacility";
import ListFacility from "./listFacility";
import PlanValudeInformation from "./planValueInformation";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import Overlay from "../../component/Overlay/Overlay";
import { setWidthModalColTable } from "../../redux/sideBar";
import { useDispatch, useSelector } from "react-redux";

const FacilityManage = () => {
  const [mode, setMode] = useState(MODE_SCREEN.VIEW);
  const [currentTableSelect, setCurrentTableSelect] = useState(null);
  const [currentNodeOverall, setCurrentNodeOverall] = useState(null);
  const [currentNodeBussiness, setCurrentNodeBussiness] = useState(null);
  const [activeTabKey, setActiveTabKey] = useState(false);
  const [activeEdit, setActiveEdit] = useState(false);
  const overviewRef = useRef({});
  const overviewPlanOriginRef = useRef({});
  const [loading, setLoading] = useState(false);
  const [overallPlanGrid, setOverrallPlanGrid] = useState(new classGrid());
  const [bussinessPlanGrid, setBussinessPlanGrid] = useState(new classGrid());
  const [kbnOptions, setKbnOption] = useState({
    facilityType: [],
    sludgeTreatmentType: [],
    sewerType: [],
    usageDistrict: [],
    waterProcessingMethod: [],
    dischargeMethod: [],
  });

  const [listSelectOverall, setListSelectOverall] = useState([]);
  const [listSelectBussiness, setListSelectBussiness] = useState([]);
  const [isFillData, setIsFillData] = useState(false);
  const inputRefs = useRef({});
  const [firstNodeFilter, setFirstNodeFilter] = useState();
  const { collapsed } = useSelector((state) => state.sideBar);
  const [triggerWidth, setTriggerWidth] = useState(false);
  const dispatch = useDispatch();

  const facilityDataOrigin = {
    facilityCode: new classDdl(),
    facilityName: new classText(""),
    facilityType: new classText(""),
    address: new classText(""),
    treatmentAreaSize: new classDdl(""),
    yearOfServiceCommencement: new classText(""),
    latitude: new classText(""),
    longitude: new classText(""),
    dischargeMethod: new classDdl(""),
    treatmentMethodWater: new classDdl(""),
    treatmentMethodSludge: new classText(""),
    currentCapacity: new classText(""),
    siteArea: new classText(""),
    structure: new classText(""),
    useDistrict: new classDdl(""),
    plannedGroundElevation: new classText(""),
    typeOfSewerage: new classDdl(""),
    outletLocation: new classText(""),
    nameOfDischargeDestination: new classText(""),
    waterLevelAtDischargeDestination: new classText(""),
    sludgeDisposalDestination: new classText(""),
    sludgeTreatmentType: new classDdl(""),
    note: new classText(""),
    imageUrl: new classText(""),
  };
  const planOrigin = {
    No: new classText(""),
    areaName: new classText(""),
    planningFormulationYear: new classText(""),
    plannedTargetYear: new classText(""),
    plannedSewageVolume: new classText(""),
    plannedMaxDailyTreatmentCap: new classText(""),
    treatmentAreaSize: new classText(""),
    plannedTreatmentPopulation: new classText(""),
    plannedInfluentWaterQualityBOD: new classText(""),
    plannedInfluentWaterQualitySS: new classText(""),
    plannedEffluentWaterQualityBOD: new classText(""),
    plannedEffluentWaterQualitySS: new classText(""),
  };
  const getInstanceData = (data) => JSON.parse(JSON.stringify(data));

  const [facilityData, setfacilityData] = useState(
    getInstanceData(facilityDataOrigin)
  );
  const [overviewPlanOrigin, setoverviewPlanOrigin] = useState(planOrigin);
  const [overallPlanData, setOverallPlanData] = useState(
    getInstanceData(planOrigin)
  );
  const [bussinessPlanData, setBussinessPlanData] = useState(
    getInstanceData(planOrigin)
  );
  function formatNumberWaterFloat(input) {
    if (input === "-" || input === "+") return input;
    if (input === null || input === undefined) return "";

    let raw = String(input).replace(/,/g, "").trim();
    if (raw === "." || raw === "+." || raw === "-.") return raw;

    let sign = "";
    if (raw[0] === "-" || raw[0] === "+") {
      sign = raw[0];
      raw = raw.slice(1);
    }

    if (raw === "") return sign;
    const [integerPart, decimalPart] = raw.split(".");

    if (integerPart !== undefined && isNaN(Number(integerPart))) {
      return sign + raw + (decimalPart !== undefined ? "." + decimalPart : "");
    }

    const formattedInteger = Number(integerPart).toLocaleString("en-US");
    if (raw.endsWith(".")) {
      return `${sign}${formattedInteger}.`;
    }

    return decimalPart !== undefined
      ? `${sign}${formattedInteger}.${decimalPart}`
      : `${sign}${formattedInteger}`;
  }
  function formatNumberWaterFloatForView(input) {
    if (input === null || input === undefined || input === "") return "";

    let raw = String(input).replace(/,/g, "").trim();

    if (raw[0] === "+" || raw[0] === "-") {
      let sign = raw[0];
      let numberPart = raw.slice(1);
      if (numberPart === "") return sign;
      const [integerPart, decimalPart] = numberPart.split(".");
      const formattedInteger = isNaN(Number(integerPart)) ? integerPart : Number(integerPart).toLocaleString("en-US");
      if (numberPart.endsWith(".")) return `${sign}${formattedInteger}.`;
      return decimalPart !== undefined
        ? `${sign}${formattedInteger}.${decimalPart}`
        : `${sign}${formattedInteger}`;
    }
    if (!isNaN(Number(raw)) && Number(raw) > 0) {
      const [integerPart, decimalPart] = raw.split(".");
      const formattedInteger = Number(integerPart).toLocaleString("en-US");
      if (raw.endsWith(".")) return `+${formattedInteger}.`;
      return decimalPart !== undefined
        ? `+${formattedInteger}.${decimalPart}`
        : `+${formattedInteger}`;
    }

    if (!isNaN(Number(raw)) && Number(raw) < 0) {
      let positiveRaw = raw.slice(1);
      const [integerPart, decimalPart] = positiveRaw.split(".");
      const formattedInteger = Number(integerPart).toLocaleString("en-US");
      if (positiveRaw.endsWith(".")) return `-${formattedInteger}.`;
      return decimalPart !== undefined
        ? `-${formattedInteger}.${decimalPart}`
        : `-${formattedInteger}`;
    }
    return raw;
  }
  const listPlan = (dataPlan, type) => [
    {
      title: "No",
      value: dataPlan.No,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "No",
    },
    {
      title: "計画策定年度",
      value: dataPlan.planningFormulationYear,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,4}$/],
      span: 1,
      key: "planningFormulationYear",
      required: true,
      disabled: type == 2,
    },
    {
      title: "計画目標年度",
      value: dataPlan.plannedTargetYear,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,4}$/],
      span: 1,
      key: "plannedTargetYear",
    },

    {
      title: "計画汚水量(m3/日)",
      value: dataPlan.plannedSewageVolume,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,5}$/],
      span: 1,
      key: "plannedSewageVolume",
      isFormatNumber: true,
    },
    {
      title: "計画処理能力日最大(m3/日)",
      value: dataPlan.plannedMaxDailyTreatmentCap,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,5}$/],
      span: 1,
      key: "plannedMaxDailyTreatmentCap",
      isFormatNumber: true,
    },
    {
      title: "処理区域面積 (ha)",
      value: dataPlan.treatmentAreaSize,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,3}(\.\d{0,3})?$/],
      span: 1,
      key: "treatmentAreaSize",
      isDecimal:3
    },
    {
      title: "計画処理人口",
      value: dataPlan.plannedTreatmentPopulation,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,5}$/],
      span: 1,
      key: "plannedTreatmentPopulation",
      isFormatNumber: true,
    },
    {
      title: "計画流入水質 BOD(mg/L)",
      value: dataPlan.plannedInfluentWaterQualityBOD,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,3}(\.\d{0,1})?$/],
      span: 1,
      key: "plannedInfluentWaterQualityBOD",
      isDecimal:1
    },
    {
      title: "計画流入水質 SS(mg/L)",
      value: dataPlan.plannedInfluentWaterQualitySS,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,3}(\.\d{0,1})?$/],
      span: 1,
      key: "plannedInfluentWaterQualitySS",
      isDecimal:1
    },
    {
      title: "計画放流水質 BOD(mg/L)",
      value: dataPlan.plannedEffluentWaterQualityBOD,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,1}(\.\d{0,1})?$/],
      span: 1,
      key: "plannedEffluentWaterQualityBOD",
      isDecimal:1
    },
    {
      title: "計画放流水質 SS(mg/L)",
      value: dataPlan.plannedEffluentWaterQualitySS,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,2}(\.\d{0,1})?$/],
      span: 1,
      key: "plannedEffluentWaterQualitySS",
      isDecimal:1
    },
  ];


  const listDataFacility = [
    {
      title: "施設区分",
      value: {
        ...facilityData.facilityType,
        options: kbnOptions.facilityType,
      },
      type: INPUT_TYPE.SELECT,
      rule: [],
      span: 1,
      key: "facilityType",
      haveEmptyOption: false,
    },
    {
      title: (
        <span
          style={{
            color: "red",
          }}
        >
          施設名称
        </span>
      ),
      value: facilityData.facilityName,
      type: INPUT_TYPE.LABEL,
      rule: [],
      span: 1,
      key: "facilityName",
    },

    {
      title: "住所",
      value: facilityData.address,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "address",
    },
    {
      title: "処理区",
      value: facilityData.treatmentAreaSize,
      type: INPUT_TYPE.LABEL,
      rule: [],
      span: 1,
      key: "treatmentAreaSize",
    },
    {
      title: "供用開始年度",
      value: facilityData.yearOfServiceCommencement,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,4}$/],
      span: 1,
      key: "yearOfServiceCommencement",
    },
    {
      title: "緯度",
      value: facilityData.latitude,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^-?$|^-?\d{1,2}(\.\d{0,6})?$/],
      span: 1,
      key: "latitude",
      isDecimal:6
    },
    {
      title: "緯度",
      value: facilityData.latitude,
      type: INPUT_TYPE.INPUT,
      span: 1,
      key: "latitude",
      rule: [/^$|^-?$|^-?\d{1,2}(\.\d{0,6})?$/],
      isDecimal:6

    },
    {
      title: "経度",
      value: facilityData.longitude,
      type: INPUT_TYPE.INPUT,
      span: 1,
      key: "longitude",
      rule: [/^$|^-?$|^-?\d{1,3}(\.\d{0,6})?$/],
      isDecimal:6

    },
    {
      title: "排除方式",
      value: {
        ...facilityData.dischargeMethod,
        options: kbnOptions.dischargeMethod,
      },
      type: INPUT_TYPE.SELECT,
      rule: [],
      span: 1,
      key: "dischargeMethod",
      haveEmptyOption: false,
    },
    {
      title: "処理方式(水処理)",
      value: {
        ...facilityData.treatmentMethodWater,
        options: kbnOptions.waterProcessingMethod,
      },
      type: INPUT_TYPE.SELECT,

      rule: [],
      span: 1,
      key: "treatmentMethodWater",
      haveEmptyOption: false,
    },
    {
      title: "処理方式(汚泥処理)",
      value: facilityData.treatmentMethodSludge,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "treatmentMethodSludge",
    },
    {
      title: "現有能力日最大",
      value: facilityData.currentCapacity,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,2}(\.\d{0,3})?$/,],
      span: 1,
      key: "currentCapacity",
      isDecimal:3
    },
    {
      title: "敷地面積",
      value: facilityData.siteArea,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,1}(\.\d{0,3})?$/,],
      span: 1,
      key: "siteArea",
      isDecimal:3
    },
    {
      title: "構造",
      value: facilityData.structure,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "structure",
    },
    {
      title: "用途地域",
      value: { ...facilityData.useDistrict, options: kbnOptions.usageDistrict },
      type: INPUT_TYPE.SELECT,

      rule: [],
      span: 1,
      key: "useDistrict",
      haveEmptyOption: false,
    },
    {
      title: "計画地盤高 (m)",
      value: facilityData.plannedGroundElevation,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.INT_10_POSITIVE],
      span: 1,
      key: "plannedGroundElevation",
      isFormatNumber: true
    },
    {
      title: "下水道の種類",
      value: { ...facilityData.typeOfSewerage, options: kbnOptions.sewerType },
      type: INPUT_TYPE.SELECT,

      rule: [],
      span: 1,
      key: "typeOfSewerage",
      haveEmptyOption: false,
    },
    {
      title: "吐口の位置",
      value: facilityData.outletLocation,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "outletLocation",
    },
    {
      title: "放流先",
      value: facilityData.nameOfDischargeDestination,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "nameOfDischargeDestination",
    },
    {
      title: "放流先水位 (m)",
      value: facilityData.waterLevelAtDischargeDestination,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^[+-]?$|^[+-]?\d{1,7}(\.\d{0,3})?$/],
      span: 1,
      key: "waterLevelAtDischargeDestination",
      isFormatNumber: true,
      isDecimal:3
    },
    {
      title: "汚泥処分先",
      value: facilityData.sludgeDisposalDestination,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "sludgeDisposalDestination",
    },
    {
      title: "汚泥処理形態",
      value: {
        ...facilityData.sludgeTreatmentType,
        options: kbnOptions.sludgeTreatmentType,
      },
      type: INPUT_TYPE.SELECT,

      rule: [],
      span: 1,
      key: "sludgeTreatmentType",
      haveEmptyOption: false,
    },
    {
      title: "その他",
      value: facilityData.note,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "note",
    },
  ];
  const [listFacility, setListFacilty] = useState(new classGrid());
  const [listDataAll, setListDataAll] = useState([]);
  const [dataSearch, setDataSearch] = useState({
    area: new classDdl(),
    facilityName: new classText(),
  });

  function revertNumber(value) { return String(value).replace(/,/g, "") }
  function handlechangeInput(objData, setObjData = () => { }) {
    return (key, value, rules = [], mode, isFormatNumber) => {
      let finalValue = isFormatNumber ? String(value).replace(/,/g, "") : value;
      if (key === "waterLevelAtDischargeDestination") {
        if (/^[+-]?\d*\.?\d*$/.test(finalValue)) {
          if (Array.isArray(rules) && rules.length > 0) {
            const isValid = rules.every((rule) => rule.test(finalValue));
            if (!isValid) {
              return;
            }
          }
          if (String(value).trim().length > 255) {
            return;
          }
          let newData = { ...objData[key], value: formatNumberWaterFloat(finalValue) };
          setObjData({
            ...objData,
            [key]: newData,
          });
          setIsFillData(true);
          return;
        }
        
      }
      else{
      if (Array.isArray(rules) && rules.length > 0) {
        const isValid = rules.every((rule) => rule.test(finalValue));
        if (!isValid) {
          return;
        }
      }
      if (String(value).trim().length > 255) {
        return;
      }
      let newData = { ...objData[key], value: isFormatNumber ? formatNumberFloat(finalValue) : finalValue };
      if (mode === MODE_SCREEN.DATE) {
        newData = {
          ...newData,
          valueString: moment(newData.value).format(KEY.DATE_DEFAULT),
        };
      }
      setObjData({
        ...objData,
        [key]: newData,
      });
      setIsFillData(true);
    }
    };
  }
  const setImageUrl = (value) => {
    setfacilityData({
      ...facilityData,
      imageUrl: {
        ...facilityData.imageUrl,
        value,
      },
    });
    setIsFillData(true);
  };
  const wrapTitlesWithSpan = (columns) =>
    columns.map((col) => ({
      ...col,
      title: <span style={{
        color: activeTab == col.key && "#fff",
      }} className="">{col.title}</span>,
    }));
  const listTab = [
    {
      title: "基本情報",
      key: "1",
      render: (tabKey) => (
        <BasicInformation
          handlechangeInput={handlechangeInput(facilityData, setfacilityData)}
          mode={mode}
          activeTabKey={activeTabKey}
          listData={listDataFacility}
          imageUrl={facilityData.imageUrl.value}
          setImageUrl={setImageUrl}
        />
      ),
    },
    {
      title: "計画値情報",
      key: "2",
      render: (tabKey) => (
        <PlanValudeInformation
          disabled={mode !== MODE_SCREEN.VIEW}
          handlechangeInputPlanOverral={handlechangeInput(
            overallPlanData,
            setOverallPlanData
          )}
          handlechangeInputPlanBussiness={handlechangeInput(
            bussinessPlanData,
            setBussinessPlanData
          )}
          listViewOverrall={listPlan(overallPlanData)}
          listViewBussiness={listPlan(bussinessPlanData, 2)}
          mode={mode}
          overallPlanGrid={overallPlanGrid}
          bussinessPlanGrid={bussinessPlanGrid}
          onSelectData={handleSelecPlan}
          currentBussiness={currentNodeBussiness}
          currentOverall={currentNodeOverall}
          listSelectOverall={listSelectOverall}
          setListSelectOverall={setListSelectOverall}
          listSelectBussiness={listSelectBussiness}
          setListSelectBussiness={setListSelectBussiness}
          inputRefs={inputRefs}
        />
      ),
    },
  ];
  const [activeTab, setActiveTab] = useState(listTab[0].key);
  // CANCEL
  const onCancel = () => {
    setMode(MODE_SCREEN.VIEW);

    handleAffterEdit(
      currentTableSelect ? currentTableSelect.facilityCode : "",
      currentNodeOverall ? currentNodeOverall.id : "",
      currentNodeBussiness ? currentNodeBussiness.id : ""
    );
    setIsFillData(false);
  };
  const handleCancel = () => {
    if (isFillData) {
      Modal.confirm({
        centered: true,
        icon: <QuestionCircleOutlined />,
        title: lang.CONFIRM,
        content: COMMON_CONSTANT.BOM_C018,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        onOk: onCancel,
      });
    } else {
      onCancel();
    }
  };

  const handleAdd = () => {
    setActiveTabKey(true);
    setMode(MODE_SCREEN.ADD);
    setBussinessPlanData(getInstanceData(planOrigin));
    setOverallPlanData(getInstanceData(planOrigin));
    setIsFillData(false);
    setFirstNodeFilter(null);
  };

  const handleEdit = () => {
    setActiveEdit(true);
    setMode(MODE_SCREEN.EDIT);
    setIsFillData(false);
  };
  const validate = () => {
    let flagErr = false;
    const planOverall = JSON.parse(JSON.stringify(overallPlanData));
    const planBussiness = JSON.parse(JSON.stringify(bussinessPlanData));
    const facility = JSON.parse(JSON.stringify(facilityData));
    const isEmptyDataOverall = Object.keys(planOverall).every((key) =>
      isEmptyData(planOverall[key].value)
    );
    const isEmptyDataBussiness = Object.keys(planBussiness).every((key) =>
      isEmptyData(planBussiness[key].value)
    );

    const isNocheckOverall = mode === MODE_SCREEN.EDIT && !currentNodeOverall;
    const isNoCheckBussiness =
      mode === MODE_SCREEN.EDIT && !currentNodeBussiness;
    let isModal = false;
    let keyFocus = "";
    let tab = "1";
    let tabModal = "";
    // TAB FACILITY
    const year = Number(facility.yearOfServiceCommencement.value);
    const latitude = Number(facility.latitude.value);
    const longitude = Number(facility.longitude.value);
    if (
      (!isEmptyData(facility.latitude.value) &&
        (latitude < -90 || latitude > 90 || isNaN(latitude)) &&
        mode === MODE_SCREEN.EDIT)
    ) {
      flagErr = true;
      isModal = true;
      facility.latitude.error = true;

      tabModal = "1";
      Modal.error({
        centered: true,
        title: lang.ERROR,
        content: "緯度は -90〜90の範囲で入力してください。",
        onOk: () => { },
      });
    }
    else {
      facility.latitude.error = false;
    }
    if (
      !isEmptyData(facility.longitude.value) &&
      (longitude < -180 || longitude > 180 || isNaN(longitude)) &&
      mode === MODE_SCREEN.EDIT
    ) {
      flagErr = true;
      facility.longitude.error = true;
      tabModal = "1";
      if (!isModal) {
        Modal.error({
          centered: true,
          title: lang.ERROR,
          content: "経度は -180〜180の範囲で入力してください。",
          onOk: () => { },
        });
      }
      isModal = true;
    }
    else {
      facility.longitude.error = false;
    }
    if (
      !isEmptyData(facility.yearOfServiceCommencement.value) &&
      (year < 1900 || year > 2080) &&
      mode === MODE_SCREEN.EDIT
    ) {
      keyFocus = "yearOfServiceCommencement";
      flagErr = true;
      facility.yearOfServiceCommencement.error = true;
      tabModal = "1";
      if (!isModal) {
        Modal.error({
          centered: true,
          title: lang.ERROR,
          content: "年の形式が正しくありません。再入力してください。",
          onOk: () => { },
        });
      }
      isModal = true;
    } else {
      facility.yearOfServiceCommencement.error = false;
    }

    // Bussiness
    if (!isNoCheckBussiness) {
      // TABPLAN
      if (isEmptyData(planBussiness.planningFormulationYear.value)) {
        flagErr = true;
        tab = "2";
        planBussiness.planningFormulationYear.error = true;
        keyFocus = "planningFormulationYear";
      } else {
        const formuYear = Number(planBussiness.planningFormulationYear.value);
        const targetYear = Number(planBussiness.plannedTargetYear.value);
        const isErrorFormulationYear = formuYear < 1900 || formuYear > 2080;
        const isErrorTargetYear =
          !isEmptyData(planBussiness.plannedTargetYear.value) && (targetYear < 1900 || targetYear > 2080);
        if (isErrorTargetYear) {
          planBussiness.plannedTargetYear.error = true;
          keyFocus = "plannedTargetYear";
        } else {
          planBussiness.plannedTargetYear.error = false;
        }
        if (isErrorFormulationYear) {
          planBussiness.planningFormulationYear.error = true;
          keyFocus = "planningFormulationYear";
        } else {
          planBussiness.planningFormulationYear.error = false;
        }
        if (isErrorFormulationYear || isErrorTargetYear) {
          flagErr = true;

          if (!isModal) {
            tabModal = "2";
            Modal.error({
              centered: true,
              title: lang.ERROR,
              content: "年の形式が正しくありません。再入力してください。",
              onOk: () => { },
            });
          }
          isModal = true;
        }
      }
    }

    // Overall
    if (!isNocheckOverall) {
      if (isEmptyData(planOverall.planningFormulationYear.value)) {
        flagErr = true;
        tab = "2";
        planOverall.planningFormulationYear.error = true;
        keyFocus = "planningFormulationYear";
      } else {
        const formuYear = Number(planOverall.planningFormulationYear.value);

        const targetYear = Number(planOverall.plannedTargetYear.value);
        const isErrorFormulationYear = formuYear < 1900 || formuYear > 2080;

        const isErrorTargetYear =
          !isEmptyData(planOverall.plannedTargetYear.value) && (targetYear < 1900 || targetYear > 2080);
        if (isErrorTargetYear) {
          planOverall.plannedTargetYear.error = true;
          keyFocus = "plannedTargetYear";
        } else {
          planOverall.plannedTargetYear.error = false;
        }
        if (isErrorFormulationYear) {
          planOverall.planningFormulationYear.error = true;
          keyFocus = "planningFormulationYear";
        } else {
          planOverall.planningFormulationYear.error = false;
        }
        if (isErrorFormulationYear || isErrorTargetYear) {
          flagErr = true;
          if (!isModal) {
            tabModal = "2";
            Modal.error({
              centered: true,
              title: lang.ERROR,
              content: "年の形式が正しくありません。再入力してください。",
              onOk: () => { },
            });
          }
        }
      }
    }
    if (keyFocus && inputRefs.current && inputRefs.current[keyFocus]) {
      inputRefs.current[keyFocus].focus();
    }
    if (flagErr) {
      setActiveTab(tabModal || tab);
    }
    setBussinessPlanData(planBussiness);
    setOverallPlanData(planOverall);
    setfacilityData(facility);
    return !flagErr;
  };

  // AFTER ADD
  const handleAfterAddPlan = async (idOver, idBu) => {
    try {
      const finalIdOver = isEmptyData(idOver)
        ? currentNodeOverall
          ? currentNodeOverall.id
          : ""
        : idOver;
      const finalIdBu = isEmptyData(idBu)
        ? currentNodeBussiness
          ? currentNodeBussiness.id
          : ""
        : idBu;
      const facilityCode = currentTableSelect
        ? currentTableSelect.facilityCode
        : "";
      const [resOverall, resBussiness] = await Promise.all([
        FacilityMasterApi.getListPlan({
          facilityCode,
          type: 1,
        }),
        FacilityMasterApi.getListPlan({
          facilityCode,
          type: 2,
        }),
      ]);
      const dataOverall = resOverall ? resOverall.data || [] : [];
      const dataBussiness = resBussiness ? resBussiness.data || [] : [];
      const currentOverall = dataOverall.find((i) => i.id == finalIdOver);
      const currentBussiness = dataBussiness.find((i) => i.id == finalIdBu);
      if (dataBussiness.length > 0) {
        setBussinessPlanGrid({
          ...bussinessPlanGrid,
          data: dataBussiness,
        });
      }
      if (dataOverall.length > 0) {
        setOverrallPlanGrid({
          ...overallPlanGrid,
          data: dataOverall,
        });
      }
      if (currentOverall) {
        handleSelecPlan(currentOverall, 1, dataBussiness);
      }
    } catch (error) {
      handleCatchError(error);
    }
  };

  const handleAffterEdit = async (facilityCode, idOver, idBu) => {
    setLoading(true);
    try {
      const res = await FacilityMasterApi.getList({
        processingArea: dataSearch.area.value,
      });
      const data = res.data || [];

      const currentFacility = data.find((i) => i.facilityCode == facilityCode);

      if (currentFacility) {
        handleSelectTable(currentFacility, idOver, idBu);
      } else {
        resetFacility();
        resetOverallPlan();
        resetBussnessPlan();
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };
  // SAVE
  const onSave = async () => {
    try {
      const dataPost = {
        facilityType: facilityData.facilityType.value,
        facilityCode: facilityData.facilityCode.value,
        facilityName: facilityData.facilityName.value,
        address: facilityData.address.value,
        processingArea: facilityData.treatmentAreaSize.value,
        serviceStartYear: facilityData.yearOfServiceCommencement.value,
        latitude: facilityData.latitude.value,
        longtitude: facilityData.longitude.value,
        dischargeMethod: facilityData.dischargeMethod.value,
        waterProcessingMethod: facilityData.treatmentMethodWater.value,
        processingMethod: facilityData.treatmentMethodSludge.value,
        sludgeTreatmentType: facilityData.sludgeTreatmentType.value,

        processingAbility: facilityData.currentCapacity.value,
        siteArea: facilityData.siteArea.value,
        structure: facilityData.structure.value,
        usageDistrict: facilityData.useDistrict.value,
        plannedGroundElevation: revertNumber(facilityData.plannedGroundElevation.value),
        sewerType: facilityData.typeOfSewerage.value,
        outletLocation: facilityData.outletLocation.value,
        dischargeDestination: facilityData.nameOfDischargeDestination.value,
        dischargeWaterLevel:
          revertNumber(facilityData.waterLevelAtDischargeDestination.value),
        sludgeDisposalSite: facilityData.sludgeDisposalDestination.value,
        note: facilityData.note.value,
        imageUrl: facilityData.imageUrl.value,
      };
      const dataPlanOverallPost = {
        facilityCode: facilityData.facilityCode.value,
        type: "1",
        planningFormulationYear: overallPlanData.planningFormulationYear.value,
        plannedTargetYear: overallPlanData.plannedTargetYear.value,
        plannedSewageVolume: revertNumber(overallPlanData.plannedSewageVolume.value),
        plannedMaxDailyTreatmentCap:
          revertNumber(overallPlanData.plannedMaxDailyTreatmentCap.value),
        treatmentAreaSize: overallPlanData.treatmentAreaSize.value,
        plannedTreatmentPopulation:
          revertNumber(overallPlanData.plannedTreatmentPopulation.value),
        plannedInfluentWaterQualityBOD:
          overallPlanData.plannedInfluentWaterQualityBOD.value,
        plannedInfluentWaterQualitySS:
          overallPlanData.plannedInfluentWaterQualitySS.value,
        plannedEffluentWaterQualityBOD:
          overallPlanData.plannedEffluentWaterQualityBOD.value,
        plannedEffluentWaterQualitySS:
          overallPlanData.plannedEffluentWaterQualitySS.value,
      };
      if (mode === MODE_SCREEN.EDIT) {
        dataPlanOverallPost.id = currentNodeOverall
          ? currentNodeOverall.id
          : null;
      }
      const dataPlanBussinessPost = {
        facilityCode: facilityData.facilityCode.value,
        type: "2",
        planningFormulationYear:
          bussinessPlanData.planningFormulationYear.value,
        plannedTargetYear: bussinessPlanData.plannedTargetYear.value,
        plannedSewageVolume: revertNumber(bussinessPlanData.plannedSewageVolume.value),
        plannedMaxDailyTreatmentCap:
          revertNumber(bussinessPlanData.plannedMaxDailyTreatmentCap.value),
        treatmentAreaSize: bussinessPlanData.treatmentAreaSize.value,
        plannedTreatmentPopulation:
          revertNumber(bussinessPlanData.plannedTreatmentPopulation.value),
        plannedInfluentWaterQualityBOD:
          bussinessPlanData.plannedInfluentWaterQualityBOD.value,
        plannedInfluentWaterQualitySS:
          bussinessPlanData.plannedInfluentWaterQualitySS.value,
        plannedEffluentWaterQualityBOD:
          bussinessPlanData.plannedEffluentWaterQualityBOD.value,
        plannedEffluentWaterQualitySS:
          bussinessPlanData.plannedEffluentWaterQualitySS.value,
      };
      if (mode === MODE_SCREEN.EDIT) {
        dataPlanBussinessPost.id = currentNodeBussiness
          ? currentNodeBussiness.id
          : null;
      }
      let resFacility;
      if (mode === MODE_SCREEN.EDIT) {
        resFacility = await FacilityMasterApi.updateFacilityNew(dataPost);
      }
      const arrAddPlan = [];
      const overallYear = overallPlanData.planningFormulationYear.value;
      const bussinessYear = bussinessPlanData.planningFormulationYear.value;
      let resPlan = [null, null];
      if (
        overallYear !== null &&
        overallYear !== undefined &&
        overallYear !== ""
      ) {
        arrAddPlan.push(() =>
          mode === MODE_SCREEN.ADD
            ? FacilityMasterApi.addPlan(dataPlanOverallPost)
            : FacilityMasterApi.updatePlan(dataPlanOverallPost)
        );
      } else {
        arrAddPlan.push(null);
      }
      if (
        bussinessYear !== null &&
        bussinessYear !== undefined &&
        bussinessYear !== ""
      ) {
        arrAddPlan.push(() =>
          mode === MODE_SCREEN.ADD
            ? FacilityMasterApi.addPlan(dataPlanBussinessPost)
            : FacilityMasterApi.updatePlan(dataPlanBussinessPost)
        );
      } else {
        arrAddPlan.push(null);
      }
      if (!arrAddPlan.every((i) => i === null)) {
        resPlan = await Promise.all(
          arrAddPlan.map((promise) => (promise !== null ? promise() : null))
        );
      }
      const resOverall = resPlan[0];
      const resBussiness = resPlan[1];
      const idFacility = resFacility ? resFacility.data : "";
      const idOver = resOverall ? resOverall.data : "";
      const idBu = resBussiness ? resBussiness.data : "";
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, () => {
        if (mode === MODE_SCREEN.ADD) {
          handleAfterAddPlan(idOver, idBu);
        } else {
          handleAffterEdit(idFacility, idOver, idBu);
        }
      });

      setMode(MODE_SCREEN.VIEW);
    } catch (error) {
      console.log(error);
      handleCatchError(error);
    }
  };

  const handleSave = () => {
    if (!validate()) {
      return;
    }
    Modal.confirm({
      centered: true,
      title: lang.CONFIRM,
      content:
        mode === MODE_SCREEN.EDIT
          ? COMMON_CONSTANT.BOM_C009
          : COMMON_CONSTANT.BOM_C008,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      icon: <QuestionCircleOutlined />,
      onOk: () => {
        onSave();
      },
      onCancel: () => { },
    });
  };

  const setDetailFacility = (dataDetail) => {
    const newFacilityData = { ...facilityData };
    newFacilityData.imageUrl.value = dataDetail.imageUrl;
    newFacilityData.facilityCode.value = dataDetail.facilityCode;
    newFacilityData.facilityType.value = dataDetail.facilityType;
    newFacilityData.facilityType.valueShow = dataDetail.facilityTypeName;
    newFacilityData.facilityName.value = dataDetail.facilityName;
    newFacilityData.address.value = dataDetail.address;
    newFacilityData.treatmentAreaSize.value = dataDetail.areaName;
    newFacilityData.yearOfServiceCommencement.value =
      dataDetail.serviceStartYear;
    newFacilityData.latitude.value = formatDecimal(dataDetail.latitude,6);
    newFacilityData.longitude.value = formatDecimal(dataDetail.longtitude,6);
    newFacilityData.dischargeMethod.value = dataDetail.dischargeMethod;
    newFacilityData.dischargeMethod.valueShow =
      dataDetail.dischargeMethodName;

    newFacilityData.treatmentMethodWater.value =
      dataDetail.waterProcessingMethod;
    newFacilityData.treatmentMethodWater.valueShow =
      dataDetail.waterProcessingMethodName;
    newFacilityData.treatmentMethodSludge.value =
      dataDetail.processingMethod;
    newFacilityData.currentCapacity.value = formatDecimal(dataDetail.processingAbility,3);
    newFacilityData.siteArea.value = formatDecimal( dataDetail.siteArea,3);
    newFacilityData.structure.value = dataDetail.structure;
    newFacilityData.useDistrict.value = dataDetail.usageDistrict;
    newFacilityData.useDistrict.valueShow = dataDetail.usageDistrictName;

    newFacilityData.plannedGroundElevation.value =
      formatNumberFloat(dataDetail.plannedGroundElevation);
    newFacilityData.typeOfSewerage.value = dataDetail.sewerType;
    newFacilityData.typeOfSewerage.valueShow = dataDetail.sewerTypeName;

    newFacilityData.outletLocation.value = dataDetail.outletLocation;
    newFacilityData.nameOfDischargeDestination.value =
      dataDetail.dischargeDestination;
    newFacilityData.waterLevelAtDischargeDestination.value =
      formatNumberWaterFloatForView(formatDecimal(dataDetail.dischargeWaterLevel,3))
    newFacilityData.sludgeDisposalDestination.value =
      dataDetail.sludgeDisposalSite;
    newFacilityData.sludgeTreatmentType.value =
      dataDetail.sludgeTreatmentType;
    newFacilityData.sludgeTreatmentType.valueShow =
      dataDetail.sludgeTreatmentTypeName;
    newFacilityData.note.value = dataDetail.note;
    newFacilityData.sludgeTreatmentType.value = dataDetail.sludgeTreatmentType
    setfacilityData(newFacilityData);
  };
  // SET DETAIL DATADETAL
  function setDetailData(dataDetail, plan1Data, plan2Data, idOver, idBu) {
    setDetailFacility(dataDetail);
    setOverrallPlanGrid({ ...overallPlanGrid, data: plan1Data });
    setBussinessPlanGrid({ ...bussinessPlanGrid, data: plan2Data });

    // SELECT FIRST
    let currentOverall;
    if (
      !isEmptyData(idOver) &&
      Array.isArray(plan1Data) &&
      plan1Data.length > 0
    ) {
      currentOverall = plan1Data.find((i) => i.id === idOver);

      if (currentOverall) {
        handleSelecPlan(currentOverall, 1, plan2Data);
      } else resetOverallPlan();
    } else if (Array.isArray(plan1Data) && plan1Data.length > 0) {
      currentOverall = plan1Data[0];
      handleSelecPlan(currentOverall, 1, plan2Data);
    } else {
      resetOverallPlan();
      resetBussnessPlan();
    }
  }
  const getDetailPlan = async (id, type) => {
    try {
      setLoading(true);
      const res = await FacilityMasterApi.getDetailPlan(id);

      const data = res.data;
      const detail =
        type == 1 ? { ...overallPlanData } : { ...bussinessPlanData };
      detail.planningFormulationYear.value = data.planningFormulationYear;
      detail.plannedTargetYear.value = data.plannedTargetYear;
      detail.plannedSewageVolume.value = formatNumberFloat(data.plannedSewageVolume,3);
      detail.plannedMaxDailyTreatmentCap.value =
        formatNumberFloat(data.plannedMaxDailyTreatmentCap,3);
      detail.treatmentAreaSize.value =formatDecimal( data.treatmentAreaSize,3);
      detail.plannedTreatmentPopulation.value = formatNumberFloat(data.plannedTreatmentPopulation);
      detail.plannedInfluentWaterQualityBOD.value =
        formatDecimal(data.plannedInfluentWaterQualityBOD,1);
      detail.plannedInfluentWaterQualitySS.value =
       formatDecimal( data.plannedInfluentWaterQualitySS,1);
      detail.plannedEffluentWaterQualityBOD.value =
       formatDecimal( data.plannedEffluentWaterQualityBOD,1);
      detail.plannedEffluentWaterQualitySS.value =
        formatDecimal(data.plannedEffluentWaterQualitySS,1);
      if (type == 1) {
        setOverallPlanData(detail);
      } else {
        setBussinessPlanData(detail);
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };

  // RESET FACILITY
  const resetFacility = () => {
    setfacilityData(getInstanceData(facilityDataOrigin));
  };

  // RESET PLAN
  const resetOverallPlan = () => {
    setCurrentNodeOverall(null);
    setOverallPlanData(getInstanceData(planOrigin));
  };
  const resetBussnessPlan = () => {
    setCurrentNodeBussiness(null);
    setBussinessPlanData(getInstanceData(planOrigin));
  };

  // SELECT PLAN
  const handleSelecPlan = useCallback(
    (node, type = 1, list) => {
      let node2;
      if (type == 1) {
        setCurrentNodeOverall(node);
        node2 = (list || bussinessPlanGrid.data).find(
          (i) => i.planningFormulationYear == node.planningFormulationYear
        );
        getDetailPlan(node ? node.id : "", 1);
        if (node2) {
          setCurrentNodeBussiness(node2);
          getDetailPlan(node2 ? node2.id : "", 2);
        } else {
          resetBussnessPlan();
        }
      } else {
        setCurrentNodeBussiness(node);
        node2 = (list || overallPlanGrid.data).find(
          (i) => i.planningFormulationYear == node.planningFormulationYear
        );
        getDetailPlan(node ? node.id : "", 2);
        if (node2) {
          setCurrentNodeOverall(node2);
          getDetailPlan(node2 ? node2.id : "", 1);
        } else {
          resetOverallPlan();
        }
      }
    },
    [bussinessPlanGrid.data, overallPlanGrid.data]
  );

  // GET DETAIL FACILITY
  const getDetailFacility = async (
    facilityCode,
    idOver,
    idBu,
    haveLoading = true
  ) => {
    try {
      if (haveLoading) {
        setLoading(true);
      }
      const [facilityRes, plan1Res, plan2Res] = await Promise.all([
        FacilityMasterApi.getFacilityNewById(facilityCode),
        FacilityMasterApi.getListPlan({
          facilityCode,
          type: 1,
        }),
        FacilityMasterApi.getListPlan({
          facilityCode,
          type: 2,
        }),
      ]);
      const dataDetail = facilityRes.data;
      const plan1Data = plan1Res.data;
      const plan2Data = plan2Res.data;
      setDetailData(dataDetail, plan1Data, plan2Data, idOver, idBu);
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };

  // SELECT TABLE
  const handleSelectTable = useCallback((node, idOver, idBu, haveLoading) => {
    setMode(MODE_SCREEN.VIEW);
    setCurrentTableSelect(node);
    getDetailFacility(node ? node.facilityCode : "", idOver, idBu, haveLoading);
    setFirstNodeFilter(null);
  }, []);

  // FILTER BY NAME
  const filterFacilityName = (value = "") => {
    const allData = JSON.parse(JSON.stringify(listDataAll));
    if (typeof value !== "string") {
      return;
    }
    const newData = allData.filter((fa) =>
      String(fa.facilityName).toLowerCase().includes(value.toLowerCase())
    );

    setListFacilty({
      ...listDataFacility,
      data: newData,
      count: newData.length,
    });
    if (Array.isArray(newData) && newData.length > 0) {
      handleSelectTable(newData[0], null, null, false);
    } else {
      resetBussnessPlan();
      resetOverallPlan();
      setOverrallPlanGrid({ ...overallPlanGrid, data: [] });
      setBussinessPlanGrid({ ...bussinessPlanGrid, data: [] });
      resetFacility();
      setCurrentTableSelect(null)
    }
  };
  const debounceFilterFacilityName = useCallback(
    debounce((value) => {
      setDataSearch((prev) => ({
        ...prev,
        facilityName: {
          ...prev.facilityName,
          value,
        },
      }));
      filterFacilityName(value);
    }, 500),
    [listDataAll]
  );
  // Change INput Search
  const changeValueInputSearch = (key, value) => {
    setDataSearch({
      ...dataSearch,
      [key]: {
        ...dataSearch[key],
        value,
      },
    });
    if (key === "area") {
      getListData(value, false);
      setDataSearch({
        ...dataSearch,
        [key]: {
          ...dataSearch[key],
          value,
        },
        facilityName: {
          ...dataSearch.facilityName,
          value: "",
        },
      });
    }
    if (key === "facilityName") {
      debounceFilterFacilityName(value);
    }
  };

  const handleAfterDelete = async () => {
    try {
      const facilityCode = currentTableSelect
        ? currentTableSelect.facilityCode
        : "";
      const [resOverall, resBussiness] = await Promise.all([
        listSelectOverall.length > 0
          ? FacilityMasterApi.getListPlan({
            facilityCode,
            type: 1,
          })
          : null,
        listSelectBussiness.length > 0
          ? FacilityMasterApi.getListPlan({
            facilityCode,
            type: 2,
          })
          : null,
      ]);
      if (resOverall && resOverall.data) {
        const dataOverall = resOverall.data || [];
        if (dataOverall.length > 0) {
          const firstItem = dataOverall[0];
          handleSelecPlan(firstItem, 1);
        } else {
          resetOverallPlan();
        }
        setOverrallPlanGrid({ ...overallPlanGrid, data: dataOverall });
      }
      if (resBussiness && resBussiness.data) {
        const dataBussiness = resBussiness.data || [];
        if (dataBussiness.length > 0) {
          const firstItem = dataBussiness[0];
          handleSelecPlan(firstItem, 2);
        } else {
          resetBussnessPlan();
        }
        setBussinessPlanGrid({ ...bussinessPlanGrid, data: dataBussiness });
        setListSelectBussiness([]);
        setListSelectOverall([]);
      }
    } catch (error) { }
  };
  // DELETE
  const showMessageDeleteConfirm = () => {
    // Action del
    const funcDel = async () => {
      try {
        setLoading(true);
        const params = new URLSearchParams();

        [...listSelectBussiness, ...listSelectOverall].forEach((id) =>
          params.append("ids", id)
        );

        await FacilityMasterApi.deletePlan(params.toString());
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004, () =>
          handleAfterDelete()
        );
      } catch (error) {
        handleCatchError(error);
      } finally {
        setLoading(false);
      }
    };

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      title: lang.DELETE,
      content: COMMON_CONSTANT.BOM_C001,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: funcDel,
      centered: true,
    });
  };

  // get KBN
  const getKbn = async () => {
    try {
      const [
        resArea,
        facilityTypeRes,
        sludgeRes,
        seweRes,
        districRes,
        dischargeRes,
        waterRes,
      ] = await Promise.all([
        kbn.getProcessArea(),
        kbn.getFacilityType(),
        kbn.getSludgeTreatmentType(),
        kbn.getSewerType(),
        kbn.getUsageDistrict(),
        kbn.getDischargeMethod(),
        kbn.getWaterTreatmentMethod(),
      ]);

      const newKbnOption = { ...kbnOptions };
      newKbnOption.facilityType = facilityTypeRes.data.data;
      newKbnOption.sludgeTreatmentType = sludgeRes.data.data;
      newKbnOption.sewerType = seweRes.data.data;
      newKbnOption.usageDistrict = districRes.data.data;
      newKbnOption.dischargeMethod = dischargeRes.data.data;
      newKbnOption.waterProcessingMethod = waterRes.data.data;

      setKbnOption(newKbnOption);
      const dataArea = resArea.data.data;
      setDataSearch({
        ...dataSearch,
        area: {
          ...dataSearch.area,
          options: dataArea,
        },
      });
    } catch (error) {
      handleCatchError(error);
    }
  };
  useEffect(() => {
    getKbn();
  }, []);

  // GET LIST DATA
  const getListData = async (processingArea, haveLoading = true) => {
    try {
      setLoading(true);
      const res = await FacilityMasterApi.getList({
        processingArea,
      });
      if (res && res.data) {
        const dataWithNo = res.data.map((item, index) => ({
          ...item,
          No: index + 1,
        }));
        setListFacilty({
          ...listDataFacility,
          data: dataWithNo,
          count: res.data.length,
        });
        setListDataAll(dataWithNo);
        if (Array.isArray(res.data) && res.data.length > 0) {
          handleSelectTable(res.data[0], null, null, haveLoading);
        } else {
          resetBussnessPlan();
          resetOverallPlan();
          resetFacility();
        }
        return res.data;
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getListData(dataSearch.area.value);
  }, []);

  // Focus First Node filter
  useEffect(() => {
    if (firstNodeFilter && mode === MODE_SCREEN.VIEW) {
      handleSelectTable(firstNodeFilter);
    } else if (firstNodeFilter === undefined) {
      resetBussnessPlan();
      resetFacility();
      resetOverallPlan();
      setCurrentTableSelect(null);
      setOverrallPlanGrid({ ...overallPlanGrid, data: [] });
      setBussinessPlanGrid({ ...bussinessPlanGrid, data: [] });
    }
  }, [firstNodeFilter]);
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);
  const isDisabledDelete =
    activeTab === "1" ||
    (listSelectBussiness.length === 0 && listSelectOverall.length === 0);

  // GET WIDTH
  const divRef = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      if (divRef.current) {
        const width = divRef.current.getBoundingClientRect().width;
        dispatch(
          setWidthModalColTable({
            key: "facilities",
            value: width,
          })
        );
      }
    }, 0);
  }, [collapsed, triggerWidth]);

  return (
    <div style={{}} className="des-content">
      <TitlePage name={"施設台帳"} style={{ fontSize: "18px" }} />
      <Overlay />

      <ReflexContainer
        orientation="vertical"
        style={{ height: "calc(100vh - 120px)", width: "100%" }}
      >
        <ReflexElement
          style={{
            overflowY: "hidden",
          }}
          flex={0.37}
          minSize={40}
          maxSize={window.innerWidth}
          onStopResize={() => {
            setTriggerWidth(!triggerWidth);
          }}
        >
          <div ref={divRef}>
            <BoxContent
              style={{ padding: "12px", margin: "8px", height: "930px" }}
            >
              <FormSearchFacility
                changeValueInputSearch={changeValueInputSearch}
                dataSearch={dataSearch}
                setDataSearch={setDataSearch}
                disabled={mode !== MODE_SCREEN.VIEW}
              />
              <ListFacility
                currentData={currentTableSelect}
                setCurrentData={handleSelectTable}
                data={listFacility}
                mode={mode}
                setFirstNodeFilter={setFirstNodeFilter}
              />
            </BoxContent>
          </div>
        </ReflexElement>
        <ReflexSplitter propagate={true} />
        <ReflexElement minSize={40} maxSize={window.innerWidth}>
          <div
            style={{
              background: "#fff",
              marginTop: "8px",
              marginBottom: "16px",
              marginLeft: 6,
            }}
          >
            <Tabs
              className="tbl-createCL tab-equipment-custom"
              type="card"
              activeKey={activeTab}
              onChange={setActiveTab}
            >
              {wrapTitlesWithSpan(listTab).map((tab) => (
                <Tabs.TabPane tab={tab.title} key={tab.key} closable={false}>
                  {tab.render(activeTab)}
                </Tabs.TabPane>
              ))}
            </Tabs>
          </div>
        </ReflexElement>
      </ReflexContainer>

      <FooterPage>
        {mode === MODE_SCREEN.VIEW ? (
          <Row justify="end">
            <Col>
              <Button
                onClick={handleAdd}
                className="buttonPC button--info wAuto ml10"
                disabled={activeTab === "1"}
              >
                <PlusOutlined />
                {lang.ADD}
              </Button>
            </Col>
            <Col>
              <Button
                disabled={
                  !currentTableSelect ||
                  (!currentNodeBussiness &&
                    !currentNodeOverall &&
                    activeTab == 2)
                }
                onClick={handleEdit}
                className="buttonPC button--outline --todo-- wAuto ml15"
              >
                <EditOutlined />
                {lang.EDIT}
              </Button>
            </Col>

            <Col>
              <Button
                onClick={showMessageDeleteConfirm}
                disabled={isDisabledDelete}
                className={`buttonPC  button--outline --todo-- ${!isDisabledDelete && "button--error--outline"
                  } ml15`}
              >
                <DeleteOutlined />
                {lang.DELETE}
              </Button>
            </Col>
          </Row>
        ) : (
          <>
            <Row justify="end">
              <Col>
                <Button
                  onClick={handleSave}
                  className="buttonPC button--info wAuto ml10"
                >
                  <SaveOutlined />
                  {lang.SAVE}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={handleCancel}
                  className="buttonPC button--outline --todo-- wAuto ml15"
                >
                  <CloseCircleOutlined />
                  {lang.CANCEL}
                </Button>
              </Col>
            </Row>
          </>
        )}
      </FooterPage>
      <Loading show={loading} />
    </div>
  );
};

export default FacilityManage;
